/**
 * Перемещение или манёвр, которые снимает отмена: без unitId — последнее
 * (кнопка отмены), с unitId — этого отряда вне очереди (двойной клик по нему).
 * Отряд возвращается на исходную ячейку, только если её не занял другой
 * отряд, пришедший туда позже, — иначе двое оказались бы на одной ячейке.
 *
 * Записи с trapTriggered: true (перемещение или манёвр, во время которого
 * сработала ловушка Гоблинов, см. APPLY_GOBLINS_TRAP_MOVEMENT) сюда не
 * попадают вообще — это необратимое действие (design.md Decision 8
 * add-goblins-faction): запись в pendingMovementActions/pendingManeuverActions
 * для него всё равно нужна (иначе бот считает отряд ещё не действовавшим и
 * повторяет действие), но отменять её нельзя.
 *
 * Вынесена в отдельный файл (была локальной функцией sharedGameStateReducer.js)
 * и экспортирована, чтобы UndoButton.js мог посчитать РЕАЛЬНУЮ доступность
 * отмены той же логикой, что и сам reducer — а не приблизительной проверкой
 * "есть хотя бы одна необратимая запись", которая может сказать "включено",
 * когда конкретно ПОСЛЕДНЯЯ (единственная, которую и снимет кнопка) запись
 * заблокирована занятой исходной ячейкой (найдено внешним ревью ветки
 * add-goblins-faction: кнопка отмены оставалась активной, но клик по ней
 * ничего не делал).
 */
export function findUndoableUnitMove(pendingMoves, units, unitId) {
  const undoableMoves = pendingMoves.filter((pendingMove) => !pendingMove.trapTriggered);
  const move = unitId
    ? undoableMoves.find((pendingMove) => pendingMove.unitId === unitId)
    : undoableMoves[undoableMoves.length - 1];
  if (!move) {
    return null;
  }

  const isOriginOccupied = units.some((unit) => unit.hexKey === move.fromHexKey && unit.id !== move.unitId);
  return isOriginOccupied ? null : move;
}
